export default "__VITE_ASSET__C0l1KGb9__"